import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, TableFilter, EmptyState } from 'core/components';
import EmptyIcon from 'themes/assets/img/building-modern.svg';
import { ApplicationListLayout, Content } from 'core/layouts';

function EligibilityStatusListTemplate({ eligibilityStatusListViewStore }) {
    const {
        tableLoading,
        tableStore,
        queryUtility,
        authorization
    } = eligibilityStatusListViewStore;
    return (
        <ApplicationListLayout store={eligibilityStatusListViewStore}>
            <Content emptyRenderer={renderEmpty()} >
                <div className='u-mar--bottom--sml'>
                    <TableFilter queryUtility={queryUtility} />
                </div>
                <div className="card--table">
                    <BaasicTable
                        tableStore={tableStore}
                        loading={tableLoading}
                        authorization={authorization}
                    />
                </div>
            </Content>
        </ApplicationListLayout>
    )
}

function renderEmpty() {
    return <EmptyState image={EmptyIcon} title='ELIGIBILITY_STATUS.LIST.EMPTY_STATE.TITLE' description='ELIGIBILITY_STATUS.LIST.EMPTY_STATE.DESCRIPTION' />
}

EligibilityStatusListTemplate.propTypes = {
    eligibilityStatusListViewStore: PropTypes.object
};

export default defaultTemplate(EligibilityStatusListTemplate);
